import React, { Component } from "react";
import HK from "factory/modules/HK";
import Link from 'components/Assets/LinkHref';
import { withRouter } from 'next/router';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { CARTAction, MBCashAvailableAction, userRoleAction } from "components/common/header/action.js";
import { searchActiveAction } from 'components/common/header/contains/Search/action.js';
import { isLogedInAction, isAssumeAction } from "factory/store/actions/";
import UniversalAnalytics from 'factory/modules/UniversalAnalytics';
import { isLoginPopupAction } from 'components/common/login/action';
import IntersectionObserver from '../../IntersectionObserver';
import dynamic from 'next/dynamic';
import styles from './header-top.module.scss';
import { convertToModule } from 'factory/utils/clientUtils';
import CartIcon from "../desktop/HeaderTopBar/CartIcon";
import { __chatSupportPopup, __getLoyaltyIconrender, __setLoyaltyDetail, __triggerLogoutEvent } from "factory/modules/HK_service";
import { GritzoLogo } from 'components/SvgStore/index';
import MenuStrip from "../desktop/MenuStrip";
import LoyalityInfoPopup from "components/Loyality/PDP/LoyalityInfoPopup";
import config from "factory/modules/config";
const SearchBox = dynamic(() => import('../contains/SearchBox'), { ssr: false });
const MobileSearch = dynamic(() => import('components/common/header/contains/MobileSearch'), { ssr: false });
class HeaderTop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleSearch: this.props.toggleSearch,
            showMenu: this.props.showMenu,
            openLoginPopup: this.props.openLoginPopup,
            isSlided: this.props.isSlided,
            showUserMenu: false,
            CART: {
                cartVariantSummaryList: [],
                noItemsInCart: 0
            },
            showBigSearch: false,
            animateCart: false,
            mobileTopIndex: -1,
            searchText: '',
            showDropdown: false,
            stickyHeaderFixClass: '',
            addPremiumPopup: false,
        };
    }
    currentPosition = 0;
    handleSearchText = (e) => {
        this.setState({
            searchText: e.target.value
        });
    };

    handlePermiumPopup = (flag) => {
        this.setState({
            addPremiumPopup: flag
        });
    };

    setAddPremiumPopup = (flag) => {
        if (this.props._userRoleReducer !== config.LOYALITY_ROLES.PREMIUM_USER) {
            this.setState({
                addPremiumPopup: flag
            });
        } else {
            this.props.router.push("/loyalty");
        }
    };

    handleScroll = () => {
        const position = window.pageYOffset;
        if (position > 109) {
            if (this.currentPosition === 0) {
                this.setState({
                    stickyHeaderFixClass: 'remove-header',
                });
                this.currentPosition = position;
            } else if (this.currentPosition > position) {
                this.setState({
                    stickyHeaderFixClass: '',
                });
                this.currentPosition = position;
            } else if (this.currentPosition < position) {
                this.setState({
                    stickyHeaderFixClass: 'remove-header',
                });
                this.currentPosition = position;
            }
        }
        else {
            this.setState({
                stickyHeaderFixClass: ''
            });
        }
    };

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        if (HK.getSearchParmas() && HK.getSearchParmas().txtQ) {
            this.setState({
                searchText: HK.getSearchParmas().txtQ
            });
        }

        let isCartPage = window.location.pathname === '/cart/Cart.action';
        if (HK.loggedIn() || localStorage.getItem("isTMPUser")) {
            HK.ajaxCall({
                url: HK.config.APIS.cart.summary,
                method: "GET"
            }).then(res => {
                const _res = res && res.data && res.data.results;
                if (_res && !_res.exception) {
                    this.props._CARTAction(_res);
                    _res.hkUserLoyaltyDetailsDto && __setLoyaltyDetail(_res.hkUserLoyaltyDetailsDto);
                    this.props._userRoleAction(_res.hkUserLoyaltyDetailsDto && _res.hkUserLoyaltyDetailsDto.role);
                }
            })
                .catch(err => { console.log(err); });
            HK.ajaxCall({
                url: HK.config.APIS.userFlow.userDetails + (isCartPage ? "?iscartpage=true" : ""),
                method: "GET"
            })
                .then(res => {
                    if (!(res && res.data && res.data.results && res.data.results.exception)) {
                        let userData = {
                            uG:
                                res.data.results.gender !== null ? res.data.results.gender : "",
                            uM: res.data.results.email !== null ? res.data.results.email : "",
                            uH: res.data.results.id,
                            contact:
                                res.data.results.cntNum !== null ? res.data.results.cntNum : "",
                            firstName:
                                res.data.results.nm != null && res.data.results.nm.length > 0
                                    ? res.data.results.nm
                                    : "User",
                            birthDt:
                                res.data.results.birthDt !== null
                                    ? res.data.results.birthDt
                                    : "",
                            tot_redeem_pts: res.data.results.tot_redeem_pts !== null ? res.data.results.tot_redeem_pts : 0
                        };
                        this.props._MBCashAvailableAction(res.data.results && res.data.results.tot_redeem_pts);
                        localStorage.setItem("userData", JSON.stringify(userData));
                        HK._dataLayer(userData);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
    triggerClickstram = (widgetName, eventName, Itemname) => {
        const eventData = {
            widgetName: widgetName,
            eventName: eventName,
            itemname: Itemname
        };
        HK.triggerComponentClickEvent(eventData);

    };
    triggerView = (widgetName, eventName, Itemname) => {
        return (inView) => {
            if (!inView) return;
            try {
                const eventData = {
                    widgetName: widgetName,
                    eventName: eventName,
                    Itemname: Itemname
                };
                HK.triggerComponentViewEvent(eventData);
            } catch (err) {
                console.log(err);
            }
        };
    };
    cartIconClick = () => {

        this.props.cartHandler();
        let eventData = {
            'event': 'ls_MB_Top-Headers',
            'eventCategory': 'Header',
            'eventAction': "Proceed to Cart",
            'eventLabel': "",
        };
        HK._setDataLayer(eventData);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.animateCart(nextProps);
        this.setState({
            CART: nextProps.CART
        });
    }

    animateCart = nxtPrps => {
        if (this.props.CART.noItemsInCart !== nxtPrps.CART.noItemsInCart) {
            this.setState({ animateCart: true });
        }
        setTimeout(() => {
            this.setState({ animateCart: false });
        }, 1000);
    };
    openLoginPopup = () => {
        if (!this.props._isLoggedIn) {
            this.props.openLoginPopup();
        }
    };
    renderCartIcon = () => {
        if (!this.state.isBigMenuOpen) {
            return (
                <Link
                    nextJSReload={true}
                    className={convertToModule(styles, "header-sprite header-sprite-cart cart Proceed_to_cart_header right-menu-item")}
                    to="/cart/Cart.action"
                >
                    {this.props.CART && this.props.CART.noItemsInCart > 0 && (
                        <span
                            id="semiBolditalic_H"
                            className={
                                "semi_bolditalic" +
                                (this.state.animateCart ? " cart-item-count-flip" : "")
                            }
                        >
                            {this.props.CART.noItemsInCart}
                        </span>
                    )}
                    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="25.445" height="27.544" viewBox="0 0 25.445 27.544"><defs><style></style><clipPath id="a"><path class="a" fill="none" clip-rule="evenodd" d="M1829.237-4875.525a8.237,8.237,0,0,0,8.238-8.237,8.237,8.237,0,0,0-8.238-8.237,8.237,8.237,0,0,0-8.237,8.237A8.237,8.237,0,0,0,1829.237-4875.525Z" transform="translate(-1821 4892)" /></clipPath><clipPath id="b"><path class="b" fill="none" d="M0,870.591H2259.4V-4925H0Z" transform="translate(0 4925)" /></clipPath></defs><g transform="translate(0 2.825)"><path class="c" fill="#1a1a1a" d="M49.739,80.559c-2.826,0-5.039-2.654-5.039-6.039a.763.763,0,0,1,.643-.808h.078a.763.763,0,0,1,.643.808c.058,2.5,1.6,4.449,3.5,4.449h.351c1.861,0,3.392-1.91,3.5-4.359v-.1a.763.763,0,0,1,.643-.808h.078c.341,0,.624.346.643.808C54.777,77.905,52.565,80.559,49.739,80.559Z" transform="translate(-38.969 -64.251)" /><path class="c" fill="#1a1a1a" d="M20.759,24.718H.737A.791.791,0,0,1,0,23.911V5a.813.813,0,0,1,.212-.551l4-4.205A.788.788,0,0,1,4.771,0h12a.814.814,0,0,1,.57.244l3.989,4.205A.881.881,0,0,1,21.552,5V23.911a.8.8,0,0,1-.737.808ZM1.564,23.141H19.977V5.795H1.564ZM2.626,4.205h16.3L16.435,1.59H5.106Z" transform="translate(0 0)" /></g><g class="d" clipPath="url(#a)" transform="translate(8.97)"><g class="e" clipPath="url(#b)" transform="translate(-2142.9 -38.833)"><path class="f" fill="#fdb53d" d="M1816-4897h28.243v28.242H1816Z" transform="translate(321.016 4929.95)" /></g></g></svg>
                </Link>
            );
        }
    };
    renderMenuIcon = () => {
        const { isloadMenu } = this.props;
        return (
            isloadMenu ?
                <IntersectionObserver onClick={() => { this.triggerClickstram('Top_Navigation', 'Top_Navigation', 'Hamburger'); this.props.hideMenu(); }} onChange={this.triggerView('Top_Navigation', 'Top_Navigation', 'Hamburger')} >
                    <svg className={convertToModule(styles, "humburger")} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" width="23" height="23" viewBox="0 0 23 23">
                        <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                        </path></svg>
                </IntersectionObserver>
                :
                <IntersectionObserver onClick={() => { this.triggerClickstram('Top_Navigation', 'Top_Navigation', 'Hamburger'); this.props.showMenu(); }} onChange={this.triggerView('Top_Navigation', 'Top_Navigation', 'Hamburger')} >

                    <svg className={convertToModule(styles, "humburger")} xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
                        <g id="Group_92180" data-name="Group 92180" transform="translate(-16 -16)">
                            <g id="_Leading_Icon_l_Use_High_Emphasis" data-name="📍 Leading Icon l Use High Emphasis" transform="translate(16 16)">
                                <rect id="Boundary" width="23" height="23" fill="none" />
                                <path id="_Color" data-name=" ↳Color" d="M22,14H0V11.667H22V14Zm0-5.833H0V5.834H22V8.166Zm0-5.834H0V0H22V2.332Z" transform="translate(1 5)" fill="#20262e" />
                            </g>
                        </g>
                    </svg>
                </IntersectionObserver>
        );
    };
    renderLogo = () => {
        return (
            <div className={convertToModule(styles, "header-mweb__logo")}>
                <Link to="/" onClick={this.props.HideFooterMenu}>
                    <div dangerouslySetInnerHTML={{ __html: GritzoLogo }} />
                    {/* <img src={HK.getImage("/mainimage.svg")} /> */}
                </Link>
            </div>
        );
    };

    getUserIcon = () => {
        return (
            <span className={convertToModule(styles, "right-menu-item")}>
                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => {
                    if (HK.loggedIn()) {
                        this.props.showUserMenu();
                    } else {
                        this.props._isLoginPopupAction({ isShow: true });
                    }
                }} width={HK.isMobile() ? "25" : "25"} height={HK.isMobile() ? "27" : "27"} viewBox="0 0 16 16"><defs></defs><path className="a" d="M972-66.1a2.1,2.1,0,0,1,2.1,2.1,2.1,2.1,0,0,1-2.1,2.1,2.1,2.1,0,0,1-2.1-2.1A2.1,2.1,0,0,1,972-66.1Zm0,9c2.97,0,6.1,1.46,6.1,2.1v1.1H965.9V-55C965.9-55.64,969.03-57.1,972-57.1ZM972-68a4,4,0,0,0-4,4,4,4,0,0,0,4,4,4,4,0,0,0,4-4A4,4,0,0,0,972-68Zm0,9c-2.67,0-8,1.34-8,4v3h16v-3C980-57.66,974.67-59,972-59Z" transform="translate(-964 68)" /></svg>
            </span>
        );
    };
    toggleMenu = (mobileTopIndex, /*event*/) => {
        let copyState = { ...this.state };
        if (copyState.mobileTopIndex == mobileTopIndex) {
            copyState.mobileTopIndex = -1;
        } else {
            copyState.mobileTopIndex = mobileTopIndex;
        }
        this.setState({ mobileTopIndex: copyState.mobileTopIndex });
    };
    logout = (/*event*/) => {
        UniversalAnalytics.LOGIN_EVENT('USER_LOGOUT', null, false);
        HK.ajaxCall({
            url: HK.config.APIS.userFlow.logout,
            method: "GET"
        }).then(() => {
            this.setState({
                showDropdown: false
            });
            __triggerLogoutEvent();
            this.props._isLogedInAction(false);
            this.props._isAssumeAction(false);
            this.props._CARTAction({
                cartVariantSummaryList: [],
                noItemsInCart: 0
            });
        }).catch(err => {
            console.log(err);
        });
    };
    redirectToHome = () => {
        let loggedInRequiredPages = [
            "cart", "selectAddress", "selectPayment", "paymentSuccess", HK.config.pageTypes.mbDataCapture, HK.config.pageTypes.gritzo.growthTrack
        ];
        if (loggedInRequiredPages.indexOf(window.pageType) > -1) {
            // this.props.history.push("/"); //todoN
            window.location.href = "/";
        }


    };
    showDropdownHanle = () => {
        if (HK.loggedIn())
            this.setState({
                showDropdown: !this.state.showDropdown
            });
        else {
            this.props._isLoginPopupAction({ isShow: true });

        }
    };
    closeModal = () => {
        this.setState({
            showDropdown: false
        });
    };
    handleUpdateEvent = () => {
        let data = {
            event_name: 'select_promotion',
            'reward_points_available': '',
            'value': '',
            'promotion_name': 'Refer and Earn',
            'creative_name': '',
            'creative_slot': ''
        };
        UniversalAnalytics.refer_and_earn(data);
    };
    handleUpdateLoyaltyEvent = () => {
        let data = {
            event_name: 'select_promotion',
            'reward_points_available': '',
            'value': '',
            'promotion_name': 'Loyalty',
            'creative_name': '',
            'creative_slot': ''
        };
        UniversalAnalytics.refer_and_earn(data);
    };

    handleLoyaltyClick = (ItemName) => {
        let data = {
            event_name: 'select_promotion',
            'reward_points_available': '',
            'value': '',
            'promotion_name': '',
            'creative_name': '',
            'creative_slot': '',
            items: [
                {
                    'item_name': ItemName || 'Profile_click',
                    'promotion_name': 'Loyalty Feature'
                }
            ]
        };
        UniversalAnalytics.LoyaltyDataLayer(data);
    };

    createTempUser = () => {
        if (!(localStorage.getItem('isUserLoggedIn') !== null && localStorage.getItem('isUserLoggedIn') !== 'false' && HK.Cookies.get('authtoken'))) {
            let reqObj = {
                method: 'get',
                url: HK.config.APIS.userFlow.tempUserCreate
            };
            HK.ajaxCall(reqObj).then((res) => {
                const _res = res && res.data && res.data.results;
                if (_res && !_res.exception) {
                    HK.Cookies.set('authtoken', '"' + _res.authToken + '"', 365);
                    localStorage.setItem('isUserLoggedIn', _res.user.id);
                    localStorage.setItem('isTMPUser', 1);
                    HK.setCookieLoggedIn(_res.user.id, 1);
                    this.setAddPremiumPopup(true);
                }
            }).catch(err => {
                HK.errorPopup("Something went wrong, please try again.", 'Got: exception::' + reqObj.url);
                HK.reportErrorToDashboard({
                    stackTrace: new Error().stack,
                    errorMessage: err
                });
            });
        }
        else {
            this.setAddPremiumPopup(true);
        }
    };

    onHelpClickHandler = () => {
        __chatSupportPopup(true);
    };

    render() {
        const { isBigMenuOpen } = this.state;
        const { /*_searchActiveReducer,*/ _searchActiveAction,/* _headerPromotionalTextReducer, _MBCashAvailableReducer,*/ _MenuData, _menuPromotionalDataReducer } = this.props;
        return (
            <div className={convertToModule(styles, 'header-mweb__outer-container')}>
                {_menuPromotionalDataReducer && <MenuStrip promotionData={_menuPromotionalDataReducer} />}
                <div className={convertToModule(styles, `header-mweb__container`)}>
                    <div className={convertToModule(styles, "HK-pagecontainer")}>
                        <div className={convertToModule(styles, 'menu-and-logo-container')}>
                            {/* ? <img onClick={this.props.hideMenu()} src={HK.getImage('/header/searchbox/close-search-mweb.svg')} alt="cross"/> : */}
                            {

                                !isBigMenuOpen && HK.isMobile(this.props) && this.renderMenuIcon()
                            }
                            {!isBigMenuOpen && this.renderLogo()}
                        </div>
                        <div className={convertToModule(styles, "header-mweb__right")}>
                            {/* <Search /> */}
                            {/* <a href='/reward/RewardPoint.action?pre=&tabId=7' className={convertToModule(styles, "mbcash")}><svg xmlns="http://www.w3.org/2000/svg" width="22.727" height="21.103" viewBox="0 0 22.727 21.103">
                                <g id="Group_88226" data-name="Group 88226" transform="translate(18732 -8829)">
                                    <path id="Path_100856" data-name="Path 100856" d="M455.812,299.123a.812.812,0,1,0-.812-.812A.812.812,0,0,0,455.812,299.123Z" transform="translate(-19170.768 8542.863)" fill="#fff" />
                                    <path id="Path_100857" data-name="Path 100857" d="M123.668,55.747v-.812a2.435,2.435,0,0,0-2.435-2.435h-13.8A2.435,2.435,0,0,0,105,54.935V71.168a2.435,2.435,0,0,0,2.435,2.435H124.48a2.435,2.435,0,0,0,2.435-2.435V67.3a2.43,2.43,0,0,0,.812-1.815V63.863a2.43,2.43,0,0,0-.812-1.815V58.182a2.435,2.435,0,0,0-2.435-2.435Zm-17.045.139a2.427,2.427,0,0,1,.812-.139h14.61v-.812a.812.812,0,0,0-.812-.812h-13.8a.812.812,0,0,0-.812.812Zm12.175,8.79a3.247,3.247,0,0,0,3.247,3.247h3.247v3.247a.812.812,0,0,1-.812.812H107.435a.812.812,0,0,1-.812-.812V58.182a.812.812,0,0,1,.812-.812H124.48a.812.812,0,0,1,.812.812v3.247h-3.247A3.247,3.247,0,0,0,118.8,64.675Zm3.247-1.623a1.623,1.623,0,1,0,0,3.247h3.247a.812.812,0,0,0,.812-.812V63.863a.812.812,0,0,0-.812-.812Z" transform="translate(-18837 8776.5)" fill="#fff" fill-rule="evenodd" />
                                </g>
                            </svg>
                               {
                                _MBCashAvailableReducer &&
                                <span className={convertToModule(styles, 'amount')}>{_MBCashAvailableReducer}</span>
                               }
                            </a> */}
                            {/* <WishListIcon pageType={this.props._pageType} isMobile = {HK.isMobile()}/>
                            <IntersectionObserver onChange={this.triggerView('Top_Navigation', 'Top_Navigation', 'Mb_Wallet')} onClick={() => {this.triggerClickstram('Top_Navigation', 'Top_Navigation', 'Mb_Wallet')}}>
                                <Itrack nextJSReload={true} classname={convertToModule(styles, "mbcash")} isFullUrl={true} isLink url="/reward/RewardPoint.action?pre=&tabId=7">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32.2 32">
                                    <g id="Group_98669" data-name="Group 98669" transform="translate(-293 -46)">
                                        <path id="Path_101712" data-name="Path 101712" d="M55.1,12.1l2.109-.1a1.053,1.053,0,0,0,.734-.993V8.231H35.2a.837.837,0,0,1-.825-.794.858.858,0,0,1,.825-.893h4.219L42.35,5.055H33.912A1.062,1.062,0,0,0,32.9,6.147V27.193a1.062,1.062,0,0,0,1.009,1.092H56.933a1.062,1.062,0,0,0,1.009-1.092V22.329a1.062,1.062,0,0,0-1.009-1.092H53.815a2.6,2.6,0,0,1-2.476-2.78V14.784c0-2.482,1.926-2.681,3.76-2.681ZM42.992,6.544H53.081l-1.926-4.17-8.163,4.17Zm11.831,0h3.118v-.4a1.062,1.062,0,0,0-1.009-1.092H54.089l.734,1.489ZM53.356,3.367h3.577a2.665,2.665,0,0,1,2.476,2.78v4.865a2.294,2.294,0,0,1-.183,1.092h.55a2.648,2.648,0,0,1,2.568,2.681v3.673a2.739,2.739,0,0,1-2.568,2.78h-.55a2.1,2.1,0,0,1,.183,1.092v4.865a2.574,2.574,0,0,1-2.476,2.681H33.912a2.648,2.648,0,0,1-2.568-2.681V6.147a2.739,2.739,0,0,1,2.568-2.78H45.56L51.246.488a.747.747,0,0,1,1.009.4l1.1,2.482Zm6.42,10.424H53.814a.9.9,0,0,0-.917.993v3.673a.992.992,0,0,0,.917,1.092h5.962a1.062,1.062,0,0,0,1.009-1.092V14.784a.976.976,0,0,0-1.009-.993Z" transform="translate(262.656 46.59)" fill="#20262e" stroke="#20262e" stroke-width="0.4"/>
                                        <path id="Path_101713" data-name="Path 101713" d="M508.376,285.658a.94.94,0,1,1-.94-.94.94.94,0,0,1,.94.94" transform="translate(-188.906 -222.507)" fill="#20262e" stroke="#20262e" stroke-width="0.4" fill-rule="evenodd"/>
                                        <g id="notifications_24px" transform="translate(293 46)">
                                        <g id="Group_96359" data-name="Group 96359">
                                            <rect id="Boundary" width="32" height="32" fill="none"/>
                                        </g>
                                        </g>
                                    </g>
                                </svg>
                                    {
                                        _MBCashAvailableReducer ?
                                        <span className={convertToModule(styles, 'amount')}>{_MBCashAvailableReducer}</span>
                                        :''
                                    }
                                </Itrack>
                            </IntersectionObserver> */}
                            <div onClick={() => this.onHelpClickHandler()}>
                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
                                    <path d="M9.38475 17.5V16H16.6923C16.7756 16 16.8477 15.9743 16.9088 15.923C16.9696 15.8718 17 15.8046 17 15.7212V8.727C17 6.81533 16.316 5.206 14.948 3.899C13.5802 2.592 11.9308 1.9385 10 1.9385C8.06917 1.9385 6.41983 2.592 5.052 3.899C3.684 5.206 3 6.81533 3 8.727V14.6152H2.25C1.7705 14.6152 1.359 14.4483 1.0155 14.1145C0.671833 13.7805 0.5 13.3737 0.5 12.8942V10.952C0.5 10.6277 0.592333 10.3305 0.777 10.0605C0.961667 9.79067 1.20267 9.57375 1.5 9.40975L1.54625 8.13275C1.62825 7.04425 1.91092 6.03592 2.39425 5.10775C2.87758 4.17958 3.49742 3.37158 4.25375 2.68375C5.01025 1.99592 5.88333 1.46 6.873 1.076C7.86283 0.691999 8.90517 0.5 10 0.5C11.0948 0.5 12.1346 0.691999 13.1193 1.076C14.1039 1.46 14.977 1.99333 15.7385 2.676C16.5 3.35867 17.1198 4.16408 17.598 5.09225C18.0762 6.02058 18.3614 7.02892 18.4538 8.11725L18.5 9.36925C18.791 9.50642 19.0304 9.70258 19.2183 9.95775C19.4061 10.2129 19.5 10.4975 19.5 10.8115V13.0442C19.5 13.3582 19.4061 13.6428 19.2183 13.898C19.0304 14.1532 18.791 14.3493 18.5 14.4865V15.7212C18.5 16.2134 18.3234 16.6329 17.9703 16.9797C17.6169 17.3266 17.1909 17.5 16.6923 17.5H9.38475ZM7.19225 10.7692C6.94742 10.7692 6.73875 10.6863 6.56625 10.5203C6.39392 10.3542 6.30775 10.1488 6.30775 9.90375C6.30775 9.65892 6.39392 9.45192 6.56625 9.28275C6.73875 9.11342 6.94742 9.02875 7.19225 9.02875C7.43725 9.02875 7.64592 9.11342 7.81825 9.28275C7.99075 9.45192 8.077 9.65892 8.077 9.90375C8.077 10.1488 7.99075 10.3542 7.81825 10.5203C7.64592 10.6863 7.43725 10.7692 7.19225 10.7692ZM12.8077 10.7692C12.5627 10.7692 12.3541 10.6863 12.1818 10.5203C12.0093 10.3542 11.923 10.1488 11.923 9.90375C11.923 9.65892 12.0093 9.45192 12.1818 9.28275C12.3541 9.11342 12.5627 9.02875 12.8077 9.02875C13.0526 9.02875 13.2612 9.11342 13.4337 9.28275C13.6061 9.45192 13.6923 9.65892 13.6923 9.90375C13.6923 10.1488 13.6061 10.3542 13.4337 10.5203C13.2612 10.6863 13.0526 10.7692 12.8077 10.7692ZM4.37125 9.2C4.26742 7.568 4.77508 6.1715 5.89425 5.0105C7.01342 3.84967 8.39867 3.26925 10.05 3.26925C11.4372 3.26925 12.6612 3.69842 13.722 4.55675C14.783 5.41508 15.4269 6.52625 15.6538 7.89025C14.2333 7.87358 12.9208 7.50058 11.7163 6.77125C10.5118 6.04175 9.58708 5.04175 8.94225 3.77125C8.68842 5.01475 8.15642 6.11408 7.34625 7.06925C6.53592 8.02442 5.54425 8.73467 4.37125 9.2Z" fill="#1C1B1F" />
                                </svg>
                            </div>
                            <div className={convertToModule(styles, "menu-search-container")} onClick={() => _searchActiveAction(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g id="search">
                                        <g id="Group 289344">
                                            <path id="Vector" d="M10.8048 19C15.1153 19 18.6096 15.4183 18.6096 11C18.6096 6.58172 15.1153 3 10.8048 3C6.49434 3 3 6.58172 3 11C3 15.4183 6.49434 19 10.8048 19Z" stroke="#002140" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path id="Vector_2" d="M20.5609 20.9999L16.317 16.6499" stroke="#002140" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </g>
                                    </g>
                                    <use href="#icon-search">
                                    </use></svg>
                                {/* <input onClick={() => _searchActiveAction(true)} placeholder="" className= {convertToModule(styles, 'menu-searchinput-box')} type="text"/> */}
                            </div>

                            {
                                __getLoyaltyIconrender(this.props._pageType) ?
                                    <div className={convertToModule(styles, "menu-search-container")}>
                                        <svg width="24" height="19" viewBox="0 0 24 19" fill="none" onClick={() => { this.createTempUser(); this.handleLoyaltyClick('Icon_click'); }}>
                                            <path d="M23.1831 6.30994L23.1821 6.30805L20.2113 0.989836L20.2113 0.989833L20.2105 0.988352C20.1283 0.843645 19.9737 0.756491 19.806 0.761161L4.19073 0.760083C4.03007 0.757008 3.87353 0.839836 3.78888 0.984736L3.78884 0.984714L3.78658 0.988775L0.82019 6.30028C0.817362 6.30486 0.814766 6.30939 0.812383 6.31385C0.809769 6.31812 0.807222 6.32257 0.804764 6.32722C0.800178 6.3359 0.796305 6.34448 0.793041 6.35289C0.781533 6.37956 0.774704 6.40443 0.770378 6.42558L0.776964 6.42693L0.770378 6.42559C0.765088 6.45146 0.76 6.48463 0.76 6.5222C0.76 6.56598 0.766993 6.60803 0.779358 6.64662C0.786936 6.67284 0.801095 6.71692 0.832559 6.76308L0.832249 6.76329L0.840419 6.77395C0.84225 6.77634 0.844077 6.77863 0.845887 6.78083C0.854326 6.79507 0.866592 6.81281 0.884078 6.83074L11.6536 18.0784L11.659 18.0872L11.6802 18.1079C11.703 18.1302 11.7253 18.1475 11.7455 18.1614L11.7703 18.1783L11.7812 18.1823C11.7914 18.1887 11.801 18.1936 11.8095 18.1975C11.8262 18.2052 11.8407 18.2095 11.8478 18.2115C11.8523 18.213 11.8561 18.2142 11.8584 18.215L11.8591 18.2152C11.8621 18.2162 11.8632 18.2166 11.8635 18.2167L11.8635 18.2168L11.8718 18.2195C11.9126 18.2328 11.9575 18.24 12.0013 18.24C12.0411 18.24 12.0763 18.2344 12.1067 18.2271C12.123 18.2241 12.1346 18.2206 12.1388 18.2193C12.1518 18.2154 12.1625 18.2112 12.1671 18.2095L12.2125 18.1917L12.2191 18.1852C12.2276 18.181 12.2353 18.1766 12.2422 18.1722C12.2493 18.168 12.2556 18.1638 12.2611 18.1599C12.2616 18.1596 12.262 18.1593 12.2625 18.159L12.2824 18.146L12.2992 18.1296C12.3225 18.1119 12.337 18.0944 12.3434 18.0865C12.3448 18.0847 12.3461 18.083 12.3472 18.0815L23.1163 6.83394L23.1244 6.82549L23.1287 6.82003L23.1306 6.81799L23.1377 6.81036C23.1478 6.79932 23.1709 6.7736 23.1899 6.73597L23.1918 6.7323C23.1926 6.7308 23.1938 6.7287 23.1951 6.72617C23.1968 6.72288 23.1989 6.71885 23.2011 6.71448C23.2058 6.7048 23.2153 6.68484 23.2227 6.65839C23.2286 6.64046 23.2354 6.61464 23.2374 6.58336C23.246 6.4997 23.2341 6.40319 23.1831 6.30994ZM13.0837 1.64789H19.1255L17.2534 5.75743L13.0837 1.64789ZM17.6779 6.96599H21.7466L13.6075 15.4719L17.6779 6.96599ZM16.3088 6.07932H11.9987H7.68869L11.9987 1.82917L16.3088 6.07932ZM6.31939 6.96599L10.3907 15.4708L2.25073 6.96599H6.31939ZM4.87413 1.64789H10.9136L6.74617 5.75526L4.87413 1.64789ZM20.2861 2.9594L20.2862 2.9595L22.0278 6.07932H18.0898L19.8599 2.19507L20.2861 2.9594ZM7.31236 6.96604H16.6861L11.9987 16.7616L7.31236 6.96604ZM1.96995 6.07948L4.13857 2.19651L5.91071 6.07948H1.96995Z" fill="#E57321" stroke="#E57321" stroke-width="0.48" />
                                        </svg>
                                    </div>

                                    : <></>
                            }

                            <CartIcon countItem={this.props.CART && this.props.CART.noItemsInCart} isMobile={HK.isMobile()} />
                            {/* {
                                this.state.showDropdown &&
                                <>
                                    <div className={convertToModule(styles, "account-menu-drawer")} >
                                        <OutsideClickListener onClick={() => this.closeModal()}>
                                            <div className={convertToModule(styles, "display_block")}>
                                                <a href="/account/MyAccount?pre=&tabId=1">Account
                                                </a>
                                                <a href="/account/MyAccountAddress?pre=&tabId=4">Address
                                                </a>
                                                <Link to="/loyalty" className={convertToModule(styles, 'refer-link-wrapper')} onClick={() => this.handleLoyaltyClick()}>
                                                    Loyalty
                                                </Link>

                                                <Link to="/refer-and-earn" className={convertToModule(styles, 'refer-link-wrapper')} onClick={() => { this.handleUpdateEvent(); }}>
                                                    Refer & Earn
                                                </Link>
                                                <a onClick={() => this.logout()}>Sign Out</a>
                                            </div>
                                        </OutsideClickListener>


                                    </div>
                                </>
                            } */}
                        </div>
                    </div>
                </div>

                {
                    <div className={convertToModule(styles, `mobOnly page-width container ${this.state.stickyHeaderFixClass}`)} >
                        <div className={convertToModule(styles, 'categoryBox')} >
                            <ul className={convertToModule(styles, 'first')}>
                                {
                                    _MenuData &&
                                    _MenuData.tpMenuNode &&
                                    _MenuData.tpMenuNode[0] &&
                                    _MenuData.tpMenuNode[0].ch &&
                                    _MenuData.tpMenuNode[0].ch.map((ele, k) => {
                                        return <li key={`ctgry_${k}`} className={convertToModule(styles, 'categoryBox_li')} ><a className={convertToModule(styles, 'hover-add')} href={`${ele.urlFragment}?navKey=${ele.navKey}`}>{ele.nm}</a></li>;
                                    })
                                }
                                <li className={convertToModule(styles, 'categoryBox_li')} ><a className={convertToModule(styles, 'hover-add')} href="https://www.gritzo.com/growthtrackr/">Growth Trackr</a></li>
                                {/* <li className={convertToModule(styles, 'categoryBox_li')} ><a className={convertToModule(styles, 'hover-add')} href="/categories/health-drink?navKey=CL-5851">Health Drinks</a></li>
                            <li className={convertToModule(styles, 'categoryBox_li')}><a className={convertToModule(styles, 'hover-add')} href="/sv/gritzo-super-milk-young-athletes-protein-n-nutrition-drink-8-12y-op/SP-119302?navKey=VRNT-226008" >Gummies</a></li>
                            <li className={convertToModule(styles, 'categoryBox_li')}><a className={convertToModule(styles, 'hover-add')} href="/categories/test/children?navKey=CL-5851">Spreads</a></li> */}
                            </ul>
                        </div>
                    </div>
                }
                {
                    this.state.addPremiumPopup ?
                        <LoyalityInfoPopup setAddPremiumPopup={this.setAddPremiumPopup} />
                        : <></>
                }

                {/* {_searchActiveReducer && <img src={HK.getImage('/header/searchbox/close-search-mweb.svg')} alt="close-search-mweb.svg" onClick={() => _searchActiveAction(false)} className={convertToModule(styles, 'close-btn-search')} />} */}
                <SearchBox handleTextChange={this.handleSearchText} searchText={this.state.searchText} />
                {this.state.mobileTopIndex == 0 && <MobileSearch menuHandler={this.toggleMenu.bind(this, -1)} displayMenuClass={this.state.mobileTopIndex == 0 ? 'display-menu' : ''} />}
            </div>
        );
    }
}
// Take value from store
function mapStateToProps(state) {
    return {
        CART: state.CARTReducer,
        _isLoggedIn: state.isLogedInReducer,
        _pageType: state.pageTypeReducer,
        _searchActiveReducer: state.searchActiveReducer,
        _headerPromotionalTextReducer: state.headerPromotionalTextReducer,
        _MBCashAvailableReducer: state.MBCashAvailableReducer,
        _MenuData: state.MenuReducer.MenuData,
        _menuPromotionalDataReducer: state.menuPromotionalDataReducer,
        _userRoleReducer: state.userRoleReducer

    };
}
// Store value
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            _isLogedInAction: isLogedInAction,
            _CARTAction: CARTAction,
            _isAssumeAction: isAssumeAction,
            _searchActiveAction: searchActiveAction,
            _isLoginPopupAction: isLoginPopupAction,
            _MBCashAvailableAction: MBCashAvailableAction,
            _userRoleAction: userRoleAction
        },
        dispatch
    );
}
export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(HeaderTop)
);